import { map } from 'lodash';

import type { OptionType } from '@hivebrite/design-system/Inputs';

import type { OptionInput } from '../types';

export const getOptions = (input?: OptionInput[]): OptionType[] =>
  map(input, ({ id, name }) => ({ label: name, value: id }));
